import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import store from './components/redux/store';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./components/jsx/AuthContextProvider.tsx";
import { createTheme, ThemeProvider } from "@mui/material/styles";

//テーマ設定（各コントローラの初期値を設定）
const myTheme = createTheme({
  typography: {
    fontFamily: ['Noto Sans JP', "sans-serif"].join(','),
  },
  components: {
    MuiAutocomplete: {
      defaultProps: {
        size: "small",
        sx: "background-color:#EBEEFC;",
      },
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
        size: "large",
        // sx: "width: 200px",
        sx: "background-color:dimgray;",
      },
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      {/* <AuthContextProvider> */}
        <ThemeProvider theme={myTheme}>
          <App />
        </ThemeProvider>
      {/* </AuthContextProvider> */}
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
